import { render } from "./VipLevelsEdit.vue?vue&type=template&id=3dcd779c"
import script from "./VipLevelsEdit.vue?vue&type=script&lang=js"
export * from "./VipLevelsEdit.vue?vue&type=script&lang=js"

import "./VipLevelsEdit.vue?vue&type=style&index=0&id=3dcd779c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__